/**
 * Die aktive Verbindung dieses Geräts zum Sync-Server. Eigenes Modul, damit
 * Abgleich (syncManager) und Audio (syncAudio) sie teilen, ohne sich
 * gegenseitig zu importieren.
 */

import { createClient } from './syncClient.js';
import { deriveSpaceKeys, fromBase64Url } from './syncCrypto.js';

/**
 * @typedef {Object} Connection
 * @property {ReturnType<typeof createClient>} client
 * @property {import('./syncCrypto.js').SpaceKeys} keys
 */

/** @type {Connection|null} */
let connection = null;

/**
 * @returns {Connection|null} null, solange das Gerät nicht gekoppelt ist
 */
export function getConnection() {
  return connection;
}

/**
 * @param {import('./syncConfig.js').SyncConfig} config
 * @returns {Promise<Connection>}
 */
export async function connect(config) {
  const keys = await deriveSpaceKeys(fromBase64Url(config.secret));
  connection = { client: createClient(config), keys };
  return connection;
}

export function disconnect() {
  connection = null;
}
